<template>
  <!--
    O `v-if="Component"` e a ausência de `mode="out-in"` são obrigatórios aqui.

    Antes era `<Transition mode="out-in">` sem o guarda. No primeiro render o
    Component ainda é indefinido, e no modo out-in a Transition segura a entrada
    do novo até a SAÍDA do anterior terminar. Quando esse fim nunca chega (por
    exemplo com as animações do sistema desligadas, o que o modo de economia de
    bateria do Android faz), nada entra: nem a tela, nem o esqueleto do Suspense.
    O aplicativo abria num retângulo branco, sem erro nenhum no caminho.
  -->
  <RouterView v-slot="{ Component }">
    <Transition name="page">
      <Suspense v-if="Component">
        <component :is="Component" />
        <template #fallback>
          <PageSkeleton />
        </template>
      </Suspense>
    </Transition>
  </RouterView>
  <ToastContainer />
  <ConfirmModal />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import PageSkeleton from "@/components/ui/PageSkeleton.vue";
import ToastContainer from "@/components/ui/ToastContainer.vue";
import ConfirmModal from "@/components/ui/ConfirmModal.vue";

const auth = useAuthStore();
onMounted(() => { auth.init(); });
</script>

<style>
.page-enter-active,
.page-leave-active { transition: opacity .15s ease, transform .15s ease; }
.page-enter-from { opacity: 0; transform: translateY(6px); }
.page-leave-to { opacity: 0; transform: translateY(-6px); }

/* Com animações desligadas no sistema (economia de bateria do Android, ou
   preferência de acessibilidade) a transição não deve existir: é justamente
   nesse cenário que ela travava a entrada da tela. */
@media (prefers-reduced-motion: reduce) {
  .page-enter-active,
  .page-leave-active { transition: none; }
  .page-enter-from,
  .page-leave-to { opacity: 1; transform: none; }
}
</style>
